import { inject, Injectable } from "@angular/core";
import { AppContext } from "./app-context.service";

@Injectable({
  providedIn: "root",
})
export class ApiProxyService {
  private appContext = inject(AppContext);
  getCountryCode(): string {
    const country = this.appContext.posAppConfig?.country;

    // For debug
    //return "cz-CZ";

    return country ? country : "";
  }
}
